/**
 * Shims v8 CommandButtonShim to render a v9 Button
 */
export { ActionButtonShim as CommandButtonShim } from './ActionButtonShim';
